export { updateWorkspaceFolder } from './updateWorkspaceFolder';
